import { Advertising, Capabilities, Device } from '@firebolt-js/sdk'
import { Logger } from '@grandstand-web/utils/logger'
import { TDeviceInfo } from '../types'

const logger = Logger.of('getComcastNativeInfo')

interface comcastDeviceDetails {
  fireboltVersion: string
  model: string
}

function parseComcastUserAgent(): comcastDeviceDetails {
  const parts = /ComcastAppPlatform\s+([\w-]+)\s+Firebolt\/(\d+\.\d+.\d+)/.exec(window.navigator.userAgent)
  const [_all, model, fireboltVersion] = parts ? parts : []
  return {
    fireboltVersion,
    model,
  }
}

export const getComcastNativeInfo = async (): Promise<TDeviceInfo> => {
  const deviceInfo: TDeviceInfo = {
    nativeVersion: 'unknown',
    apiVersion: 'unknown',
    ...parseComcastUserAgent(),
  }

  try {
    // @ts-ignore
    const info = await Capabilities.request([{ role: 'use', capability: 'xrn:firebolt:capability:device:info' }])
    console.log('Comcast device info', info)
  } catch (error) {
    logger.warn('Unable to get comcast device info', error)
    return deviceInfo
  }

  try {
    const versions = await Device.version()
    deviceInfo.apiVersion = versions.api.readable
    deviceInfo.osVersion = versions.os.readable
    console.log('Comcast versions', versions)
  } catch (error) {
    logger.warn('Unable to get comcast device versions', error)
  }

  try {
    const advertising = await Advertising.advertisingId()
    deviceInfo.advertisingId = advertising.ifa
    deviceInfo.isLAT = advertising.lmt === '1'
    console.log('Comcast ad info', advertising)
  } catch (error) {
    logger.warn('Unable to get comcast ad info', error)
  }

  return deviceInfo
}
